import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tasco_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const vnd = (n) =>
  new Intl.NumberFormat('vi-VN').format(Math.round(n || 0)) + '₫';

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export default api;
